const NotFound = () => (
  <div>Not found page content</div>
);

export default NotFound;
